(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('BilanNationalDeleteController',BilanNationalDeleteController);

    BilanNationalDeleteController.$inject = ['$uibModalInstance', 'entity', 'BilanNational'];

    function BilanNationalDeleteController($uibModalInstance, entity, BilanNational) {
        var vm = this;

        vm.bilanNational = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BilanNational.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
